// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Ecclesiasticus (Sirach)",
  bookSlug: "ecclesiasticus",
  chapter: 22,
  argument: "Wise sayings on divers subjects.",
  verses: [
    { n: 1, text: "The sluggard is pelted with a dirty stone, and all men will speak of his disgrace." },
    { n: 2, text: "The sluggard is pelted with the dung of oxen: and every one that toucheth him will shake his hands." },
    { n: 3, text: "A son ill taught is the confusion of the father: and a foolish daughter shall be to his loss." },
    { n: 4, text: "A wise daughter shall bring an inheritance to her husband: but she that confoundeth, becometh a disgrace to her father." },
    { n: 5, text: "She that is bold shameth both her father and husband, and will not be inferior to the ungodly: and shall be disgraced by them both." },
    { n: 6, text: "A tale out of time is like music in mourning: but the stripes and instruction of wisdom are never out of time." },
    { n: 7, text: "He that teacheth a fool, is like one that glueth a potsherd together." },
    { n: 8, text: "He that telleth a word to him that heareth not, is like one that waketh a man out of a deep sleep." },
    { n: 9, text: "He speaketh with one that is asleep, who uttereth wisdom to a fool: and in the end of the discourse he saith: Who is this?" },
    { n: 10, text: "Weep for the dead, for his light hath failed: and weep for the fool, for his understanding faileth." },
    { n: 11, text: "Weep but a little for the dead, for he is at rest." },
    { n: 12, text: "For the wicked life of a wicked fool is worse than death." },
    { n: 13, text: "The mourning for the dead is seven days: but for a fool and an ungodly man all the days of their life." },
    { n: 14, text: "Talk not much with a fool, and go not with him that hath no sense." },
    { n: 15, text: "Keep thyself from him, that thou mayst not have trouble, and thou shalt not be defiled with his sin." },
    { n: 16, text: "Turn away from him, and thou shalt find rest, and shalt not be wearied out with his folly." },
    { n: 17, text: "What is heavier than lead? and what other name hath he but fool?" },
    { n: 18, text: "Sand and salt, and a mass of iron, is easier to bear, than a man without sense, that is both foolish and wicked." },
    { n: 19, text: "A frame of wood bound together in the foundation of a building, shall not be loosed: so neither shall the heart that is established by advised counsel." },
    { n: 20, text: "The thought of him that is wise at all times, shall not be depraved by fear." },
    { n: 21, text: "As pales set in high places, and plasterings made without cost, will not stand against the face of the wind:" },
    { n: 22, text: "So also a fearful heart in the imagination of a fool shall not resist against the violence of fear." },
    { n: 23, text: "As a fearful heart in the thought of a fool at all times will not fear, so neither shall he that continueth always in the commandments of God." },
    { n: 24, text: "He that pricketh the eye, bringeth out tears: and he that pricketh the heart, bringeth forth resentment." },
    { n: 25, text: "He that flingeth a stone at birds, shall drive them away: so he that upbraideth his friend, breaketh friendship." },
    { n: 26, text: "Although thou hast drawn a sword at a friend, despair not: for there may be a returning. To a friend," },
    { n: 27, text: "If thou hast opened a sad mouth, fear not, for there may be a reconciliation: except upbraiding, and reproach, and pride, and disclosing of secrets, or a treacherous wound: for in all these cases a friend will flee away." },
    { n: 28, text: "Keep fidelity with a friend in his poverty, that in his prosperity also thou mayst rejoice." },
    { n: 29, text: "In the time of his trouble continue faithful to him, that thou mayst also be heir with him in his inheritance." },
    { n: 30, text: "As the vapour of a chimney, and the smoke of the fire goeth up before the fire: so also injurious words, and reproaches, and threats, before blood." },
    { n: 31, text: "I will not be ashamed to salute a friend, neither will I hide myself from his face: and if any evil happen to me by him, I will bear it." },
    { n: 32, text: "But every one that shall hear it, will beware of him." },
    { n: 33, text: "Who will set a guard before my mouth, and a sure seal upon my lips, that I fall not by them, and that my tongue destroy me not?" },
  ],
  commentary: [
    { verse: 1, notes: [
      { text: "Sluggard. Who neglects his own and others' welfare. (Calmet) — Disgrace. He is still despised here, and punished eternally, Matthew xxv. 30.", attribution: "Worthington" }
    ] },
    { verse: 2, notes: [
      { text: "Pelted. Greek, \"compared to a lump of dung.\"", attribution: "Haydock" }
    ] },
    { verse: 3, notes: [
      { text: "Loss. \"I wish,\" said Augustus, \"I had never married, or that I had died without children.\"", attribution: "Suetonius" }
    ] },
    { verse: 4, notes: [
      { text: "Inheritance. Her wisdom and economy, Proverbs xxxi. 29. Women had no inheritance among the Jews, when they had brothers.", attribution: "Haydock" }
    ] },
    { verse: 5, notes: [
      { text: "Bold. In speaking and acting without restraint.", attribution: "Calmet" }
    ] },
    { verse: 6, notes: [
      { text: "Mourning. St. Jerome (ep. ad Julian) quoting this sentence, calls it \"divine Scripture,\" Proverb xxv. 20. — Of time. Or \"stripes and instruction well-timed, are wisdom.\" (Haydock) — Only the wise know how to correct with advantage.", attribution: "Haydock" }
    ] },
    { verse: 7, notes: [
      { text: "Fool. Who is incapable of understanding. Those who have sense may be corrected, though they may have taken evil courses.", attribution: "Haydock" }
    ] },
    { verse: 9, notes: [
      { text: "This? The Athenian philosophers and Festus derided St. Paul, Acts xvii. 32.", attribution: "Haydock" }
    ] },
    { verse: 10, notes: [
      { text: "For the fool. In the language of the Holy Ghost, he is styled a fool that turns away from God to follow vanity and sin. And what is said by the wise man against fools is meant of such fools as these. (Challoner) — Their wicked life is worse than death.", attribution: "Worthington" }
    ] },
    { verse: 13, notes: [
      { text: "Days. There was a longer time assigned for great men, Genesis l. 3., Numbers xx. 30., and Deuteronomy xxxiv. 8. — Life. This is understood of those who have lost all reason, or sense of religion. St. Monica wept for her son, hoping that he would repent, as a certain bishop had comforted her.", attribution: "St. Augustine, Confessions iii. ultra.[last chapter]" }
    ] },
    { verse: 17, notes: [
      { text: "Lead? Gold alone is heavier. But the fool is compared with lead, and is most insupportable.", attribution: "Haydock" }
    ] },
    { verse: 19, notes: [
      { text: "Wood. Such were used in the walls of Jerusalem, (4 Machabees ii.) and of the temple and palace, 3 Kings vi. 36., and vii. 12.", attribution: "Haydock" }
    ] },
    { verse: 21, notes: [
      { text: "Cost. Of lime. (Calmet) — Greek omits this comparison, as well as the 23d verse.", attribution: "Haydock" }
    ] },
    { verse: 23, notes: [
      { text: "Not fear. This seems contrary to what goes before. But fools are sometimes intrepid even to harshness.", attribution: "Calmet" }
    ] },
    { verse: 24, notes: [
      { text: "Resentment. Or \"sense,\" (Haydock) by means of pungent reprimands.", attribution: "Calmet" }
    ] },
    { verse: 25, notes: [
      { text: "Away. Greek literally, \"will knock them down,\" dejiciet. (Haydock) — Deliberate provocations (", attribution: "Haydock" }
    ] },
    { verse: 27, notes: [
      { text: ") are pardoned with more difficulty than a sudden impulse of wrath,", attribution: "Haydock" }
    ] },
    { verse: 26, notes: [
      { text: "On such occasions we may withdraw our confidence, but not our charity and patience, Matthew v. 11. (Calmet) — A true friend will not be lost for a temporal damage; but he must not be slighted.", attribution: "Worthington" }
    ] },
    { verse: 29, notes: [
      { text: "Inheritance. Greek adds, \"for poverty is not always contemptible, nor is the senseless rich worthy of admiration.\"", attribution: "Haydock" }
    ] },
    { verse: 32, notes: [
      { text: "Of him. Yet I will not follow their example. (Calmet) — If my friend has behaved ill to me, he will be the greatest sufferer.", attribution: "Haydock" }
    ] },
    { verse: 33, notes: [
      { text: "Not. Psalm cxl. 3. Who can sufficiently guard his tongue?", attribution: "Calmet" }
    ] },
  ],
};

export default chapter;
